import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    ...theme.mixins.appClickableContainer,
    ...theme.mixins.appContainersSpacing,
    cursor: 'default',
    '&:hover': {
      borderColor: 'transparent',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
  },
  leftBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    minWidth: 0,
  },
  titleSkeleton: {
    width: '100%',
    maxWidth: '70%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  subtitleSkeleton: {
    width: '100%',
    maxWidth: '50%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  iconsBlock: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    flexShrink: 0,
  },
  iconSkeleton: {
    flexShrink: 0,
  },
}));
